export enum RouteTransition {
  Default = 'default',
  SlideRelatives = 'slide-relatives',
}

export interface TransitionDefinitionObject<T extends RouteTransition = RouteTransition, U extends object = object> {
  name: T;
  options?: U;
}

export type TransitionDefinition<T extends RouteTransition = RouteTransition, U extends object = object> =
  | T
  | TransitionDefinitionObject<T, U>;

export function getTransitionConfig<T extends RouteTransition, U extends object>(
  value: TransitionDefinition<T, U>,
): TransitionDefinitionObject<T, U> {
  if (typeof value === 'object') {
    return value;
  }

  return {
    name: value,
  };
}
